import { panelService } from '@/services/api/panel.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { panelModel } from '@/models/api/panel.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PANEL_MODULE = "api/panel";

// ACTIONS
export const GET_ALL_PANEL = 'getAllPanel';
export const CREATE_PANEL = 'createPanel';
export const GET_PANEL = 'getPanel';
export const UPDATE_PANEL = 'updatePanel';
export const UPDATE_PANEL_STATUS = 'updatePanelStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PANEL_SUCCESS = "allPanelSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PANEL_SUCCESS = "getPanelSuccess";

export const actions = {
    [GET_ALL_PANEL]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        panelService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PANEL_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PANEL]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return panelService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PANEL, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PANEL]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return panelService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PANEL_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PANEL]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return panelService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PANEL, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PANEL_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return panelService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PANEL, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PANEL_SUCCESS](state, {data}) {
        let panelList = data.data || [];
        state.list.data = panelList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = panelList.map(item => panelModel(item));
        }
    },
    [GET_PANEL_SUCCESS](state, data) {
        state.details = panelModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
